export default __webpack_public_path__ + "static/media/logoLine.7f16ac7b.webp";